export default "__VITE_PUBLIC_ASSET__20a77799__"